import '@/app.js'
import {initial} from "@/app";
import * as rebidModule from "@intec/cetp-rebidding-absentee/index.js";
import * as accredModule from "@intec/cetp-accreditation/index.js";
import * as itemizedAuctionDownModule from "@intec/cetp-itemized-auction-down/index.js";
import * as tenderModule from "@intec/cetp-tender/index.js";

initial([
    {name: 'rebiddingAbs', module: rebidModule},
    {name: 'accreditation', module: accredModule},
    {name: 'itemizedAuctionDown', module: itemizedAuctionDownModule},
    {name: 'tender', module: tenderModule},
])
